import React from 'react';
import {
  Button,
  Card,
  CardContent,
  CardFooter,
} from '@exiftrator/shared/components/ui';
import { cn } from '../../utils/cn';

function SettingsEntityCard({
  title,
  icon: Icon,
  badge,
  metadata,
  description,
  thumbnail,
  thumbnailLayout = 'inline',
  thumbnailClassName,
  onEdit,
  onDelete,
  editLabel = 'Edit',
  deleteLabel = 'Delete',
  actions,
  className,
  children,
}) {
  return (
    <Card className={cn('py-0 gap-0 overflow-hidden border-border-default/70 bg-bg-secondary shadow-sm', className)}>
      <CardContent className="p-4 space-y-3">
        {thumbnail && thumbnailLayout === 'top' ? (
          <div
            className={cn(
              'h-32 w-full overflow-hidden rounded-md border border-border-default/70 bg-bg-tertiary/50',
              thumbnailClassName,
            )}
          >
            {thumbnail}
          </div>
        ) : null}

        <div
          className={cn(
            'flex gap-3',
            thumbnail && thumbnailLayout === 'inline' ? 'items-start' : 'items-center',
          )}
        >
          {thumbnail && thumbnailLayout === 'inline' ? (
            <div
              className={cn(
                'h-16 w-16 shrink-0 overflow-hidden rounded-md border border-border-default/70 bg-bg-tertiary/50',
                thumbnailClassName,
              )}
            >
              {thumbnail}
            </div>
          ) : null}

          <div className="min-w-0 flex-1 space-y-2">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 flex items-center gap-2">
                {Icon && <Icon className="size-4 shrink-0 text-text-supporting" />}
                <p className="truncate text-sm font-semibold text-text-primary">{title}</p>
              </div>
              {badge && <div className="shrink-0">{badge}</div>}
            </div>

            {metadata ? (
              <div className="text-xs text-text-supporting leading-relaxed">{metadata}</div>
            ) : null}

            {description ? (
              <p className="text-xs text-text-secondary leading-relaxed line-clamp-2">{description}</p>
            ) : null}

            {children}
          </div>
        </div>
      </CardContent>

      <CardFooter className="border-t border-border-subtle bg-bg-tertiary/35 px-4 py-3 gap-2">
        {actions ? (
          actions
        ) : (
          <>
            {onEdit ? (
              <Button
                type="button"
                variant="outline"
                size="sm"
                className="flex-1"
                onClick={onEdit}
              >
                {editLabel}
              </Button>
            ) : null}
            {onDelete ? (
              <Button
                type="button"
                variant="outline"
                size="sm"
                className="flex-1 border-destructive/40 text-destructive hover:border-destructive hover:bg-destructive/10 hover:text-destructive"
                onClick={onDelete}
              >
                {deleteLabel}
              </Button>
            ) : null}
          </>
        )}
      </CardFooter>
    </Card>
  );
}

export default SettingsEntityCard;
